// An analyst tab's Section 2 (Additional Certifications) is resolved when the
// tab has no templates, or every template code has a Certified, Declined or
// Escalated row. A Pending row (the judgment path creates one on first touch)
// or a missing one leaves it open. The server refuses the lane issue until it
// is resolved (owner approval, 2026-10-13). Server copy:
// AnalystSectionTwoCompletion.UnresolvedCodes; fixture:
// tests/fixtures/analyst-section2-completion-cases.json.

const RESOLVED = new Set(["Certified", "Declined", "Escalated"]);

/** The template codes still open, in template order. */
export function unresolvedSectionTwoCodes(
  templateCodes: readonly string[],
  rows: readonly { certificationCode: string; status: string }[],
): string[] {
  const resolved = new Set(rows.filter((r) => RESOLVED.has(r.status)).map((r) => r.certificationCode));
  return templateCodes.filter((code) => !resolved.has(code));
}
